import MenuIcon from "@mui/icons-material/Menu";
import {
  AutocompleteChangeReason,
  Avatar,
  Box,
  Button,
  Divider,
  Fab,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useEffect, useState, createContext } from "react";
import styles from "../Styles/mainHeader.module.css";
import Logout from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { Vocabulary } from "../Utils/Vocabulary";
import { isDefined, logout, readCookie } from "../Utils/Utils";
import useNoActivity from "../Hooks/useNoActivity";
import GenericModal from "./GenericModal";
import { UserModel } from "../Utils/Models";
import UserForm from "./Users/UserForm";
import { getData } from "../Services/getData";
import genericStyles from "../Styles/genericStyles.module.css";
import { EWidths } from "../Utils/Enums";
import SearchComponent from "./SearchComponent";
import { MainHeaderProps } from "../Utils/Types";
import {  FormsIds } from "../Utils/Constants";
import { NotificationsActive, Block } from "@mui/icons-material";
// import Task from "./Tasks/Task";
import Notifications from "./Widgets/Notifications";

export const CRUDContext = createContext(new UserModel());
let logoutTimeout: any;

export default function MainHeader(props: MainHeaderProps) {
  const [contextValue, setContextValue] = useState(new UserModel());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const hasActivity = useNoActivity();
  const open = Boolean(anchorEl);
  const [openModalUser, setOpenModalUser] = useState(false);
  const clientId = localStorage.getItem("clientId");
  const [openModal, setOpenModal] = useState(false);
  const [changedPassword, setChangedPassword] = useState(true);

  /**
   *
   */
  useEffect(() => {
    if (!hasActivity) {
      logoutTimeout = setTimeout(() => {
        handleLogout();
      }, 1000 * 60 * 5);
    } else {
      if (logoutTimeout) {
        clearTimeout(logoutTimeout);
      }
    }
  }, [hasActivity]);

  /**
   * Check if we need to open the password modal after login
   */
  useEffect(() => {
    const shouldOpenPasswordModal = localStorage.getItem("openPasswordModal");
    if (shouldOpenPasswordModal === "true") {
      localStorage.removeItem("openPasswordModal");
      getUserInfo();
      setOpenModalUser(true);
    }
  }, []);

  /**
   *
   */
  useEffect(() => {
    // notifications
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("applewebkit") && ua.includes("mobile")) {
      //nu facem nimic
    } else {
      if (
        typeof Notification !== "undefined" &&
        Notification?.permission !== "granted"
      ) {
        const notificationCookie = readCookie("accept_notification");
        if (!isDefined(notificationCookie) || notificationCookie == "false") {
          setOpenModal(true);
          document.cookie = "accept_notification =;";
        } else if (notificationCookie === "true") {
          Notification.requestPermission().then((permission) => {
            //nu facem nimic
          });
        }
      }
    }
  }, []);

  /**
   *
   */
  const handleToggleModal = () => {
    setOpenModal(!openModal);
  };

  /**
   *
   * @returns
   */
  const getUserInfo = async () => {
    const url = `${endpoints.client.main}/${clientId}`;
    const res = (await getData(url)) as any;
    if (!res || res?.error) {
      return;
    }
    setContextValue(res?.data);
    // Treat missing/undefined/null as false (password not changed)
    setChangedPassword(res?.data?.changedPassword === true);
  };

  /**
   *
   * @param event
   */
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   *
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   *
   */
  const handleLogout = async () => {
    setAnchorEl(null);
    logout();
    navigate(localUrlEnum.login);
  };

  /**
   *
   */
  const redirectToSettings = () => {
    setAnchorEl(null);
    setOpenModalUser(true);
  };

  const userName = localStorage.getItem("fullName");

  /**
   *
   */
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("applewebkit") && ua.includes("mobile")) {
      //nu facem nimic
    } else {
      document.cookie = "accept_notification = true;";
      Notification.requestPermission().then((permission) => {
        //nu facem nimic
      });
    }
    handleToggleModal();
  };

  return (
    <CRUDContext.Provider value={contextValue}>
      <div className={styles.container}>
        <div className={styles.secondContainer}>
          <div className={styles.iconMenu}>
            <IconButton
              style={{ backgroundColor: "#fff" }}
              aria-label="add"
              onClick={() => props.setHideSlider()}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div style={{ marginLeft: 5 }}>
            <a href="/">
              <img
                src={"/sigur-la-volan.png"}
                alt="SigurLaVolan"
                width={200}
                style={{ maxWidth: '200px', height: 'auto' }}
              />
            </a>
          </div>
        </div>
        {props.shouldRenderSearchBar && (
          <div className={genericStyles.searchField}>
            <SearchComponent />
          </div>
        )}
        <div className={styles.secondContainer}>
          <Typography className={styles.username}>{userName}</Typography>
          <Fab
            onClick={(event: any) => {
              getUserInfo();
              handleClick(event);
            }}
            size="small"
            className={styles.userSettingsAvatar}
            aria-label="add"
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <AccountCircleIcon />
          </Fab>
          <Notifications />
          {/* <NewMessageAnimated /> */}
          {/* <Task name={ComponentsNames.Task} /> */}
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={redirectToSettings}>
              <Avatar />
              {Vocabulary.myAccount}
            </MenuItem>
          
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              {Vocabulary.logout}
            </MenuItem>
          </Menu>
          <GenericModal
            onClose={() => {
              setOpenModalUser(false);
              setContextValue(new UserModel());
            }}
            maxWidth={EWidths.MD}
            open={openModalUser}
            actions={
              <div className={genericStyles.modalActions}>
                <Button
                  color="secondary"
                  onClick={() => {
                    setOpenModalUser(false);
                    setContextValue(new UserModel());
                  }}
                  variant="outlined"
                  fullWidth
                >
                  {Vocabulary.cancel}
                </Button>
                <Button
                  fullWidth
                  type="submit"
                  form={FormsIds.usersForm}
                  variant="contained"
                >
                  {Vocabulary.save}
                </Button>
              </div>
            }
            title={changedPassword ? Vocabulary.editModalTitle : Vocabulary.changePasswordTitle}
          >
            <UserForm
              setContextValue={(
                e: any,
                client: UserModel | null,
                reason: AutocompleteChangeReason,
                details?: any
              ) => ({})}
              selectedUser={CRUDContext}
              onClose={() => {
                setOpenModalUser(false);
                setContextValue(new UserModel());
              }}
            />
          </GenericModal>

          {/* ALLOW BROWSER NOTIFICATIONS MODAL */}
          <GenericModal
            open={openModal}
            onClose={handleToggleModal}
            maxWidth={EWidths.SM}
            title=""
            actions={
              <>
                <Button
                  variant="outlined"
                  onClick={handleToggleModal}
                  startIcon={<Block />}
                  color="error"
                >
                  {Vocabulary.block}
                </Button>
                
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  startIcon={<NotificationsActive />}
                  color="primary"
                >
                  {Vocabulary.allow}
                </Button>
              </>
            }
          >
            <Box sx={{ textAlign: 'center', pt: 2, pb: 2 }}>
              <Box sx={{ mb: 3 }}>
                <NotificationsActive 
                  sx={{
                    fontSize: 64,
                    color: 'primary.main',
                    background: 'linear-gradient(135deg, rgba(21, 101, 192, 0.1) 0%, rgba(21, 101, 192, 0.2) 100%)',
                    borderRadius: '50%',
                    padding: 2,
                    boxShadow: (theme) => `0 4px 20px ${theme.palette.primary.main}30`
                  }}
                />
              </Box>
              
              <Typography 
                variant="h5" 
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  mb: 2,
                  fontSize: '1.5rem'
                }}
              >
                {Vocabulary.allowBrowserNotifications}
              </Typography>
              
              <Typography 
                variant="body1" 
                sx={{
                  color: 'text.secondary',
                  lineHeight: 1.6,
                  fontSize: '1rem'
                }}
              >
                {Vocabulary.notificationDescription}
              </Typography>
            </Box>
          </GenericModal>
          {/** END ALLOW BROWSER NOTIFICATIONS MODAL */}
        </div>
      </div>
    </CRUDContext.Provider>
  );
}
